import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lstVe0: [],
		ve0: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, ve0){
			state.ve0 = ve0
			if (ve0)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.ve0 = null
		},
		setParamsDataTable(state, payload){
			state.lstVe0 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, ve0vend){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Vendor/Vendor/Find/${ve0vend}`)
			.then(response => {
				let ve0 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", ve0)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		async save(store, { asDialog = false }){
			if (store.state.update){
				await store.dispatch("update", { asDialog: asDialog })
				return
			}
			await store.dispatch("insert", { asDialog: asDialog })
		},
		async insert(store, { asDialog = false }){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Vendor/Vendor/Insert", store.state.ve0)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				if (!asDialog)
					router.push("/oryxpdv/vendedores")
				store.state.ve0 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store, { asDialog = false }){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Vendor/Vendor/Update", store.state.ve0)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				if (!asDialog)
					router.push("/oryxpdv/vendedores")
				store.state.ve0 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store, { asDialog = false }){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Vendor/Vendor/Delete/${store.state.ve0.ve0vend}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				if (!asDialog)
					router.push("/oryxpdv/vendedores")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Vendor/Vendor/FindList")
			.then(response => {
				let lstVe0 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstVe0 = lstVe0
				store.state.hasNext = lstVe0.length > store.state.itemsPerPage
			})
			.catch((error) => {
				store.state.lstVe0 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
		},
		async search(store, { text = '', limit = 20, page = 1, ve0ativo = false, fieldsToReturn = [] }){
			store.state.loading = true
			store.commit("initForm")
			try{
				const response = await this._vm.$axios.get(`/Vendor/Vendor/Search?search=${!!text ? text : store.state.search}&onlyActives=${ve0ativo}&limit=${limit}&page=${page}`)
				const payload = Utils.ValidateAxiosResponse(response.data) || {}
				const fullList = payload.items || []

				store.commit("setParamsDataTable", payload)

				return Utils.PickProps(fullList, fieldsToReturn)
			}
			catch(error){
				store.state.lstVe0 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			}
			finally{
				store.state.loading = false
			}
		},
		async printReportSalesByVendorRanking(store, { since , until, detail }){
			if (!since)
				since = moment().format("YYYY-MM-DDT00:00")
			if (!until)
				until = moment().format("YYYY-MM-DDT23:59")
				
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Vendor/Vendor/PrintReportSalesByVendorRanking", {
				since,
				until,
				detail
			})
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);
				if (relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		}
	}
}
